export enum FormQuestionTypeKeys {
  address = 'address',
  allergy = 'allergy',
  copay = 'copay',
  date = 'date',
  demographics = 'demographics',
  dropdown = 'dropdown',
  eSignature = 'e_signature',
  email = 'email',
  familyHistory = 'family_history',
  group = 'group',
  immunizationHistory = 'immunization_history',
  informationCapture = 'information_capture',
  insuranceCard = 'insurance_card',
  insuranceVerification = 'insurance_verification',
  jump = 'jump',
  longText = 'long_text',
  medicationList = 'medication_list',
  medicationSearch = 'medication_search',
  multipleChoice = 'multiple_choice',
  patientInformation = 'patient_information',
  pharmacySearch = 'pharmacy_search',
  phoneNumber = 'phone_number',
  shortText = 'short_text',
  socialHistory = 'social_history',
  ssn = 'ssn',
  surgicalHistory = 'surgical_history',
  template = 'template',
  twoFactor = '2FA',
  yesNo = 'yes_no',
  zipcode = 'zipcode',
}

type TQuestion = {
  id: string;
  type: FormQuestionTypeKeys;
  title: string;
  description?: string;
  text?: string;
  squiggly?: string;
  redirectType?: string;
  properties: any;
  validations: {
    required?: boolean;
  };
};

type TQuestions = {
  amount: number;
  current: TQuestion;
  currentQuestionIndex: number;
  currentQuestionNumber: number;
  hasJumpLogicInForm: boolean;
  hasJumpoLogicOnForm: true;
  next: TQuestion;
  nextQuestionIndex: number;
  previous: TQuestion;
  previousQuestionIndex: number;
  progressPercentage: number;
};

export type TCustomForm = {
  _id: string;
  deleted: 0;
  status: string;
  processingStatus: string;
  path: string[];
  availabilities: string[];
  facilities: string[];
  lumabot: boolean;
  patient: string;
  patientFormTemplate: string;
  querystring: any;
  createdBy: string;
  updatedBy: string;
  user: string;
  integratorUpdateResults: any;
  patientFormTemplateType: string;
  patientFormTemplateName: string;
  createdAt: Date;
  updatedAt: Date;
  questions: TQuestions;
};

export type TFetchCustomFormsParameters = {
  patient?: string;
  patientFormTemplate?: string;
  user?: string;
};

export type TNavigatePreviousQuestionParameters = { customFormId: string };

export type TSaveQuestionAnswerParameters = {
  customFormId: string;
  question: any;
};

export type TStartCustomFormParameters = { customFormId: string };

export type TRestartCustomFormParameters = { customFormId: string };
